import { Box, Button, Heading, Skeleton, Text } from '@optiaxiom/react';

export default function Loading() {
  return (
    <Box gap="24" display="flex" flexDirection="column" pt="24" pb="24" pr="32" h="full">
      <Box display="flex" gap="24" flexDirection="column" w="full">
        <Box display="flex" flexDirection="column" gap="8">
          <Skeleton>
            <Heading level="3" />
          </Skeleton>
          <Skeleton>
            <Text />
          </Skeleton>
        </Box>
        <Box display="flex" justifyContent="end">
          <Skeleton style={{ width: '132px' }}>
            <Button />
          </Skeleton>
        </Box>
      </Box>
      <Skeleton style={{ height: '110px' }} />
      <Skeleton style={{ height: '110px' }} />
    </Box>
  );
}
